var map = {
	"./de.json": 803830,
	"./en.json": 137864,
	"./es.json": 870077,
	"./fr.json": 908452,
	"./it.json": 979565,
	"./ja.json": 762795,
	"./ko.json": 103562,
	"./pl.json": 741141,
	"./pt.json": 658723,
	"./ru.json": 580109,
	"./uk.json": 90592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 322551;